"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationSchemaProperties = exports.ConversationSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.ConversationSchema = base_schema_1.BaseSchema.extend({
    organizationId: zod_1.z.string(),
    accountId: zod_1.z.string(),
    sessionId: zod_1.z.string().optional(),
    history: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string(),
        role: zod_1.z.enum(["user", "model"]),
        text: zod_1.z.string(),
    }))
        .optional(),
});
exports.ConversationSchemaProperties = {
    collectionName: "conversations",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=conversation-schema.js.map